module.exports = __webpack_public_path__ + "static/media/PRSmall1Web.3e22ad46.webp";